module.exports = "/_next/static/images/transfez-card-physical-8bd799bbaf8b47eac37ad462baf2f76f.svg";